import React from "react";
import {
  ListContainer,
  PanelBody,
  PanelContainer,
  PanelHeader,
  PanelHeaderTitle,
} from "../../../styled/common";
import {
  EmptyGuestText,
  RegisteredGuests,
  BottomButtonContainer,
  TextBottomBoxes,
	TextBottomBoxesItem
} from "./styled";
import GuestItem from "../../GuestsList/GuestItem/";
import TextButtonBox from "../../TextButtonBox";
import Button from "../Buttons";
import whiteArrowRight from "../../../assets/icons/arrowNext.svg";

type PanelGuestsListProps = {
  guests: any[];
  totalGuests: number;
  currentRegisteredGuests: number;
};

const defaultProps: PanelGuestsListProps = {
  guests: [],
  totalGuests: 0,
  currentRegisteredGuests: 0,
};

function PanelGuestsList({
  guests,
  totalGuests,
  currentRegisteredGuests,
}: PanelGuestsListProps) {
  const emptyGuests = currentRegisteredGuests === 0;
  return (
    <>
      <PanelContainer>
        <PanelHeader>
          <PanelHeaderTitle>Guests List</PanelHeaderTitle>
          <RegisteredGuests>
            {totalGuests}/{currentRegisteredGuests} registered
          </RegisteredGuests>
        </PanelHeader>
        <PanelBody emptyGuests={emptyGuests}>
          {emptyGuests ? (
            <EmptyGuestText>There are not registered guests yet</EmptyGuestText>
          ) : (
            <ListContainer>
              {guests.map((guest, i) => {
                return <GuestItem key={i} guest={guest} />;
              })}
            </ListContainer>
          )}
        </PanelBody>
        {!emptyGuests && (
          <BottomButtonContainer>
            <Button
              rounded
              primary
              label={"Regiester new guest"}
              iconRight={whiteArrowRight}
              width={'250px'}
            />
          </BottomButtonContainer>
        )}
      </PanelContainer>
      <TextBottomBoxes>
        <TextBottomBoxesItem>
          <TextButtonBox
            text={"Do you want the pending guest to register themselves?"}
            buttonLabel={"Share registrarion link"}
            buttonWidth={'220px'}
          />
        </TextBottomBoxesItem>
        <TextBottomBoxesItem paddingLeft={'13%'}>
          <TextButtonBox
            text={"Or there are no more guest to register?"}
            buttonLabel={"All guests are registered"}
            buttonWidth={'230px'}
          />
        </TextBottomBoxesItem>
      </TextBottomBoxes>
    </>
  );
}

PanelGuestsList.defaultProps = defaultProps;

export { PanelGuestsList };
